const Modal = require('app/ui/Modal');
const GraphQLMutation = require('app/graphql/Mutation');

class ExportModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': "Export de l'analyse",
            'parameters': [],
            'onClose': function(event){},
            'onShown': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitForm = this.onSubmitForm.bind(this);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('order-analyse-export-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    refresh(){
        this.buildContent();
    }

    buildContent(){
        this.$resultContainer = $('<div/>');

        this.$inputShowTotal = $('<input/>')
        .attr('type','checkbox')
        .attr('id','showTotal')
        .attr('name','showTotal')
        .addClass('form-check-input')
        .attr('checked','checked')
        .val(1);

        this.$selectType = $('<select/>')
        .addClass('form-control')
        .attr('id','type')
        .attr('name','type')
        .attr('required','required')
        .append(
            $('<option/>')
            .val('')
            .html('Choix du format')
        )
        .append(
            $('<option/>')
            .val('excel')
            .html('Excel')
        )
        .append(
            $('<option/>')
            .val('pdf')
            .html('PDF')
        )
        

        this.$form = $('<form/>')
        .on('submit',this.onSubmitForm)
        .attr('name','exportForm')
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','type')
                .html('Type de fichier')
            )
            .append(this.$selectType)
        )
        .append(
            $('<div/>')
            .addClass('form-check')
            .append(
                $('<label/>')
                .attr('for','showTotal')
                .addClass('form-check-label')
                .html('Afficher les totaux')
            )
            .append(this.$inputShowTotal)
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(
                $('<button/>')
                .attr('type','submit')
                .addClass('btn btn-primary')
                .html('Générer le fichier')
            )
        )


        this.$content
        .append(
            this.$form
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$resultContainer)
        )
    }


    onSubmitForm(event){
        event.preventDefault();
        this.generateFile();
    }

    generateFile(){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())
        .show();


        let type = this.$selectType.val();
        let showTotal = this.$inputShowTotal.is(':checked') ? true : false;

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'type':{
                'value': type,
                'type': "String!"
            },
            'showTotal':{
                'value': showTotal,
                'type': "Boolean!"
            },
            'parameters': {
                'value': JSON.stringify(this.settings.parameters),
                "type": "String!"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ExportRestaurantOrderAnalyse",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    self.showResult(data);
                }else{
                    window.notify(data.message,'error');
                    
                    this.$resultContainer
                    .html('')
                    .append(
                        $('<div/>')
                        .addClass('alert alert-danger')
                        .append('Une erreur est advenue lors de la génération du fichier, veuillez réessayer.')
                    );
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
                
                this.$resultContainer
                .html('')
                .append(
                    $('<div/>')
                    .addClass('alert alert-danger')
                    .append('Une erreur est advenue lors de la génération du fichier, veuillez réessayer.')
                );
            },
            'after': function(){
            }
        });
        mutation.execute();

    }

    showResult(data){
        let url = window.App.get('apiBaseUrl')+data.file.url;

        let type = this.$selectType.val();

        let $buttonShow = $('<a/>')
        .attr('download','download')
        .attr('target','_blank')
        .attr('href',url)
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass("fas fa-file-"+type+" me-1")
        )
        .append("Télécharger")


        this.$resultContainer
        .html('')
        .append($buttonShow)
        .show();
    }
}

module.exports = ExportModal;

